export default __webpack_public_path__ + "static/media/university-of-michigan-logo.4dc1c386.png";